import { render, staticRenderFns } from "./PdpRelatedPairedArticles.vue?vue&type=template&id=52247d33&scoped=true"
import script from "./PdpRelatedPairedArticles.vue?vue&type=script&lang=js"
export * from "./PdpRelatedPairedArticles.vue?vue&type=script&lang=js"
import style0 from "./PdpRelatedPairedArticles.vue?vue&type=style&index=0&id=52247d33&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52247d33",
  null
  
)

/* custom blocks */
import block0 from "./translations?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fdata%2Fwww%2Fsrc%2Fcomponents%2F03-organisms%2Fproduct-details-26%2Fsubcomponents%2Fpdp-related-articles%2FPdpRelatedPairedArticles.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports